import { Route, Routes } from 'react-router-dom'
import { AuthWrapped } from '~/modules/navigation/components'
import { PppTabs } from '~/modules/ppp/view'
import { PATH } from '~/AppRoutes'
import { useCanViewPpp } from '~/modules/ppp/hooks'

export const PppRoutes = () => {
  const canAccess = useCanViewPpp()
  return (
    <Routes>
      <Route index element={<AuthWrapped component={PppTabs} canAccess={canAccess} />} />
      <Route path="customs" element={<AuthWrapped component={PppTabs} canAccess={canAccess} />} />
      <Route path="relations" element={<AuthWrapped component={PppTabs} canAccess={canAccess} />} />
    </Routes>
  )
}

export const pppLinks = {
  pppLink: () => PATH.OVERVIEW,
  pppCustomsLink: () => `/customs`,
  pppRelationsLink: () => `/relations`,
}
